import { Button } from "@bowfast/ui/components/button";
import { CompassIcon, MapIcon, PlusIcon } from "lucide-react";

export function EmptyRoutes() {
  return (
    <div className="flex flex-col items-center justify-center gap-5 py-16 text-center">
      <div className="relative">
        <div className="flex size-16 items-center justify-center rounded-2xl bg-muted">
          <MapIcon className="size-8 text-muted-foreground/40" />
        </div>
        <CompassIcon className="absolute -right-4 -top-4 size-8 rotate-12 text-abyss-200/30" />
      </div>
      <div className="max-w-sm">
        <p className="font-heading text-base font-semibold">No routes saved.</p>
        <p className="mt-1 text-sm text-muted-foreground">Build a route to reuse across multiple expeditions.</p>
      </div>
      <Button>
        <PlusIcon data-icon="inline-start" />
        Plot your first route
      </Button>
    </div>
  );
}
